import { render, staticRenderFns } from "./btn-adicionar-no-carrinho.html?vue&type=template&id=5fe0e4d4&scoped=true&"
import script from "./btn-adicionar-no-carrinho.vue?vue&type=script&lang=js&"
export * from "./btn-adicionar-no-carrinho.vue?vue&type=script&lang=js&"
import style0 from "./btn-adicionar-no-carrinho.less?vue&type=style&index=0&id=5fe0e4d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0e4d4",
  null
  
)

export default component.exports